import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import ProtectedRoute from "./router/ProtectedRoute";
import { AdminRoute } from "./router/ProtectedRoute";

// === Pages principales ===
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Tokenomics from "./pages/Tokenomics";
import Roadmap from "./pages/Roadmap";
import Buy from "./pages/Buy";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import Whitepaper from "./pages/Whitepaper";
import SubmitProposal from "./pages/SubmitProposal";

// 💎 Page 404
const NotFound = () => (
  <div className="text-center py-40 text-white text-2xl">
    🚫 Page not found —{" "}
    <a href="/" className="text-neonPink underline hover:text-neonBlue transition">
      Return Home
    </a>
  </div>
);

// 🌀 Écran de chargement global
const LoadingScreen = () => (
  <div className="flex items-center justify-center h-screen bg-darkBg text-neonPink text-lg animate-pulse">
    Initializing NEXORA Universe...
  </div>
);

export default function App() {
  return (
    <Layout>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          {/* === PAGES PUBLIQUES === */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/tokenomics" element={<Tokenomics />} />
          <Route path="/roadmap" element={<Roadmap />} />
          <Route path="/buy" element={<Buy />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/whitepaper" element={<Whitepaper />} />
          <Route path="/submitproposal" element={<SubmitProposal />} />

          {/* === Dashboard accessible à TOUS les wallets connectés === */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute requireWallet>
                <Dashboard />
              </ProtectedRoute>
            }
          />

          {/* === Page Admin réservée à l’adresse ADMIN === */}
          <Route
            path="/admin"
            element={
              <AdminRoute>
                <Admin />
              </AdminRoute>
            }
          />

          {/* === 404 === */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}
